<template>
    <div class="row">
        <div class="col-md-12">
            <seccion-datos :titulo="autovisita" :botonGuardar="false" class="card">
                <div class="row">
                    <label for="">Puede modificarse las coordenadas de la dirección del operario marcándolas en el mapa.</label>
                </div>
                <br>
                <div class="row">
                    <div style="height: 400px;" class="col-md-12">
                         <l-map 
                            v-if="centro[0] != 39.4746227" 
                            id="map" 
                            v-model:zoom="zoom" 
                            :maxZoom="maxZoom" 
                            :minZoom="minZoom"
                            :center="centro"
                            @mousedown="onMapMouseDown"
                            @mouseup="onMapMouseUp"
                            @move="onMapMove"
                        >
                            <l-tile-layer  
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
                                layer-type="base"
                                name="OpenStreetMap">
                            </l-tile-layer>
                            <l-marker v-if="coordenadas" :lat-lng="coordenadas"></l-marker>
                        </l-map>
                    </div>
                </div>
            </seccion-datos>
        </div>
    </div>
</template>
<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker} from "@vue-leaflet/vue-leaflet";
import L from 'leaflet';
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'operario', 'coordenadas_operario', 'cargaauto'],
    data() {
        return {
            centro: [39.4746227, -0.3477796],
            coordenadas: '',
            zoom: 13,
            iconWidth: 25,
            iconHeight: 40,
            maxZoom: 19,
            minZoom: 2,  
            mapMoved: false,
        }
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
    },
    watch: {
        coordenadas_operario() {
             this.$nextTick(() => {
                this.cargardatos();
            });
        },
        cargaauto() {
             this.$nextTick(() => {
                    this.cargardatos();
                });
        }
    },
    methods: {
        onMapMouseDown() {
            this.mapMoved = false;
        },
        onMapMouseUp(event) {
            if (!this.mapMoved) {
                this.confirmar(event);
            }
        },
        onMapMove() {
            this.mapMoved = true;
        },
        async cargardatos() {
            console.log('entra123', this.cargaauto);
            if(this.cargaauto){
                setTimeout(() => {
                    let aux1 = '';
                    console.log('entracargar', this.coordenadas_operario);
                    for (let j = 0; j <= this.coordenadas_operario.length; j++) {
                        if (this.coordenadas_operario[j] == ",") { 
                            aux1 = L.latLng(this.coordenadas_operario.slice(0, j), this.coordenadas_operario.slice(j + 1));
                        }
                    }
                    console.log('entracargar2', aux1);
                    this.centro = aux1;
                    this.coordenadas = aux1;
                    this.zoom = 13;
                }, 1000);
            }
        },
        confirmar(event) {
            this.$confirm.require({
                message: '¿Modificar las coordenadas?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.editarCoordenadas(event)
                },
                reject: () => {
                    return;
                }
            });        
        },
        async editarCoordenadas(event) {
            const { lat, lng } = event.latlng;
            try {
                const api = new PwgsApi();
                var coordenadas = [lat, lng];
                await api.put('operarios/'+this.id+'/coordenadas', {coordenadas: lat + ',' + lng});
                this.coordenadas = coordenadas;
                this.centro = coordenadas;
                this.$toast.add({ severity: 'success', summary: 'Actualizadas', detail: 'Coordenadas actualizadas correctamente', life: 2000 });
            } catch(e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'e', life: 2000 });
            }
        },
    },
}
</script>
<style>
.map-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
}

#map {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
